import styled from 'styled-components'

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ProgressPillWrapper = styled.div<{
  $disabled?: boolean
  $compact?: boolean
}>`
  width: 88px;
  height: 17px;
  background-color: ${(props) =>
    props.$disabled ? props.theme.colors.skeleton : props.theme.colors.surface.muted};
  border-radius: 8px;
  position: relative;
  overflow: hidden;

  ${(props) =>
    props.$compact &&
    `
    width: 63px;
    height: 12px;
  `}
`

export const ProgressFill = styled.div<{ fill: number; disabled?: boolean }>`
  height: 100%;
  background-color: ${(props) =>
    props.disabled
      ? props.theme.colors.skeleton.primary
      : props.theme.colors.brand.primaryBlue};
  border-radius: 8px;
  width: ${({ fill }) => `${fill}%`};
`

export const ProgressPercentage = styled.div`
  font-size: 13px;
  margin-top: 5px;
  color: black;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.typography.fontInter};
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`
